import React from "react";
import { Row, Col, Tag, Typography, Divider, Space, List } from "antd";
import dayjs from "dayjs";

const FollowCustomerTab = ({ followCusData }) => {
  return (
    <>
      <Divider orientation="left">
        <Space>
          <Typography.Text strong style={{ cursor: "pointer" }}>
            ข้อมูลจากทีม "Collector"
          </Typography.Text>
          <Tag color="blue" style={{ cursor: "pointer" }}>
            {followCusData ? followCusData?.length : 0} รายการ
          </Tag>
        </Space>
      </Divider>

      <Row gutter={[0, 16]}>
        <Col span={24}>
          <List
            style={{ borderRadius: 8, overflow: "hidden" }}
            bordered
            dataSource={followCusData}
            locale={{ emptyText: "ไม่มีข้อมูลติดตาม" }}
            renderItem={(item, index) => (
              <List.Item
                style={{
                  backgroundColor: index % 2 === 0 ? "#f0f7ff" : "#ffffff",
                  padding: "12px 16px",
                  alignItems: "stretch", // เพื่อให้ความสูงของกล่องยืดเท่ากัน
                  width: "100%",
                }}
              >
                {/* Layout ซ้าย-ขวา */}
                <Row
                  style={{ width: "100%", alignItems: "stretch" }} // เพิ่ม alignItems stretch ตรงนี้ด้วย
                  gutter={[16, 0]}
                >
                  {/* ฝั่งซ้าย: ข้อมูล */}
                  <Col
                    xs={18}
                    sm={8}
                    md={6}
                    style={{
                      // ใช้ borderRight เป็นเส้นกั้นแนวตั้ง
                      borderRight: "1px solid #d9d9d9",
                      paddingRight: "16px", // เพิ่มระยะห่างก่อนถึงเส้น
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center", // จัดให้อยู่ตรงกลางแนวตั้ง
                    }}
                  >
                    <Space
                      direction="vertical"
                      size={4}
                      style={{ width: "100%" }}
                    >
                      {/* RUNNO + สถานะ */}
                      <Space size={4} wrap>
                        <Tag
                          color="geekblue"
                          style={{ borderRadius: 10, fontSize: 14 }}
                        >
                          {item?.RUNNO}
                        </Tag>
                        {/* <Tag
                          color={item?.CALLSTAT === "Y" ? "success" : "error"}
                          style={{ borderRadius: 10, fontSize: 11 }}
                        >
                          {item?.CALLSTAT === "Y" ? "โทรติด" : "โทรไม่ติด"}
                        </Tag> */}
                      </Space>

                      {/* รหัสพนักงาน */}
                      <Space size={4}>
                        <Typography.Text
                          type="secondary"
                          style={{ fontSize: 14, minWidth: 100 }}
                        >
                          รหัสพนักงาน :
                        </Typography.Text>
                        <Typography.Text
                          strong
                          style={{ color: "#1a365d", fontSize: 14 }}
                        >
                          {item?.USERID}
                        </Typography.Text>
                      </Space>

                      {/* โทรเมื่อ */}
                      <Space size={4}>
                        <Typography.Text
                          type="secondary"
                          style={{ fontSize: 14, minWidth: 100 }}
                        >
                          📞 โทรเมื่อ :
                        </Typography.Text>
                        <Tag
                          color="blue"
                          style={{
                            borderRadius: 10,
                            fontSize: 14,
                            margin: 0,
                          }}
                        >
                          {dayjs(item?.TELDT).format("DD/MM/YYYY")}
                        </Tag>
                      </Space>

                      {/* ลูกค้านัด */}
                      <Space size={4}>
                        <Typography.Text
                          type="secondary"
                          style={{ fontSize: 14, minWidth: 100 }}
                        >
                          📅 ลูกค้านัด :
                        </Typography.Text>
                        {item?.MEETDT ? (
                          <Tag
                            color="purple"
                            style={{
                              borderRadius: 10,
                              fontSize: 14,
                              margin: 0,
                            }}
                          >
                            {dayjs(item?.MEETDT).format("DD/MM/YYYY")}
                          </Tag>
                        ) : (
                          <Typography.Text
                            type="secondary"
                            style={{ fontSize: 14 }}
                          >
                            -
                          </Typography.Text>
                        )}
                      </Space>

                      {/* ลงข้อมูลเมื่อ */}
                      <Space size={4}>
                        <Typography.Text
                          type="secondary"
                          style={{ fontSize: 14, minWidth: 100 }}
                        >
                          🕐 ลงข้อมูลเมื่อ :
                        </Typography.Text>
                        <Typography.Text
                          style={{ fontSize: 14, color: "#555" }}
                        >
                          {dayjs(item?.INPDATE).format("DD/MM/YYYY HH:mm")}
                        </Typography.Text>
                      </Space>
                    </Space>
                  </Col>

                  {/* ฝั่งขวา: REMARK */}
                  <Col
                    xs={24}
                    sm={12}
                    md={14}
                    style={{
                      paddingLeft: "10px",
                    }}
                  >
                    <Tag color="blue"> หมายเหตุ : </Tag>

                    <Typography.Text
                      style={{
                        fontSize: 16,
                        color: "#333",
                        whiteSpace: "pre-wrap",
                        lineHeight: 1.8,
                        flex: 1,
                      }}
                      copyable={{
                        text: `${item?.REMARK}\nโทร: ${dayjs(item?.TELDT).format("DD/MM/YYYY")}${item?.MEETDT ? ` | นัด: ${dayjs(item?.MEETDT).format("DD/MM/YYYY")}` : ""}\nบันทึกโดย: ${item?.USERID}`,
                        tooltips: ["คัดลอก", "คัดลอกแล้ว!"],
                      }}
                    >
                      {item?.REMARK || (
                        <Typography.Text type="secondary">-</Typography.Text>
                      )}
                    </Typography.Text>
                  </Col>
                </Row>
              </List.Item>
            )}
          />
        </Col>
      </Row>
    </>
  );
};

export default FollowCustomerTab;
